import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, data: null });
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState({ loading: false, data: null }); return; }
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await api.get(`/reservations/status/${sid}`);
        if (data.payment_status === "paid" || tries > 20) { setState({ loading: false, data }); return; }
        setTimeout(poll, 1500);
      } catch { setState({ loading: false, data: null }); }
    };
    poll();
  }, [params]);

  if (state.loading) return <div className="max-w-2xl mx-auto p-16 text-center" data-testid="pay-loading">
    <Loader2 className="mx-auto animate-spin text-emerald-700" size={40}/>
    <p className="mt-4 text-stone-600">Confirmation du paiement en cours…</p>
  </div>;

  const d = state.data;
  const ok = d && d.payment_status === "paid";
  return (
    <div className="max-w-2xl mx-auto p-8 py-16 text-center" data-testid="pay-success-page">
      {ok ? (
        <>
          <CheckCircle2 className="mx-auto text-emerald-600" size={64}/>
          <h1 className="font-serif text-3xl text-emerald-900 mt-4">Réservation confirmée</h1>
          <p className="text-stone-600 mt-2">Votre paiement a été validé.</p>
          <div className="mt-6 p-5 bg-emerald-50 border border-emerald-200 rounded-xl text-left inline-block">
            <div><strong>Référence :</strong> {d.reference}</div>
            <div><strong>Hutte :</strong> {d.hut_name}</div>
            <div><strong>Date :</strong> {d.date}</div>
            <div><strong>Montant :</strong> {d.amount} €</div>
          </div>
          <p className="mt-6 text-sm text-stone-600">Un email de confirmation avec les codes d'accès vous a été envoyé.</p>
          <Link to="/" className="mt-8 inline-block bg-emerald-800 hover:bg-emerald-900 text-white px-6 py-3 rounded-md">Retour à l'accueil</Link>
        </>
      ) : (
        <>
          <XCircle className="mx-auto text-red-600" size={64}/>
          <h1 className="font-serif text-3xl text-red-900 mt-4">Paiement non confirmé</h1>
          <p className="text-stone-600 mt-2">Nous n'avons pas pu confirmer votre paiement. Merci de réessayer ou de nous contacter.</p>
          <Link to="/reserver" className="mt-6 inline-block bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-md">Retourner à la réservation</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto p-8 py-16 text-center" data-testid="pay-cancel-page">
      <XCircle className="mx-auto text-amber-600" size={64}/>
      <h1 className="font-serif text-3xl text-emerald-900 mt-4">Paiement annulé</h1>
      <p className="text-stone-600 mt-2">Votre réservation n'a pas été enregistrée. La date reste disponible.</p>
      <Link to="/reserver" className="mt-6 inline-block bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-md">Réessayer</Link>
    </div>
  );
}
